<template>
  <div id="auth-layout">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "auth-layout"
};
</script>
